module.exports = __webpack_public_path__ + "img/p2.53565f01.png";